import { TsrctSourcingCaseStatus } from '@/generated/gql/graphql';

const SOURCING_CASE_STATUS_EDITABLE: Record<TsrctSourcingCaseStatus, boolean> = {
  [TsrctSourcingCaseStatus.DRAFT]: true,
  [TsrctSourcingCaseStatus.RELEASABLE]: true,
  [TsrctSourcingCaseStatus.RELEASED]: false,
  [TsrctSourcingCaseStatus.SUPPLIER_AGREEMENT_REACHED]: false,
  [TsrctSourcingCaseStatus.AWARDED]: false,
  [TsrctSourcingCaseStatus.OFFER_DISMISSED]: false,
  [TsrctSourcingCaseStatus.CANCELLED]: false,
};

export const isSourcingCaseEditable = (sourcingCase?: { status: TsrctSourcingCaseStatus }) => {
  return sourcingCase ? SOURCING_CASE_STATUS_EDITABLE[sourcingCase.status] : false;
};
